module.exports = __webpack_public_path__ + "img/2014-2.2a74cbc1.jpg";